/**
 * Auth API service
 *
 * NOTE: These calls target a different host (`VITE_AUTH_API_BASE_URL`) than
 * the portal service whose OpenAPI document lives at
 * `https://preprod-portalservice.hellohealth.com/v3/api-docs`. Their
 * request/response shapes are therefore NOT covered by
 * `src/shared/api/swagger.d.ts` and we cannot pull generated wire types here
 * the way the rest of the codebase does.
 *
 * Until the auth service publishes an OpenAPI document, the wire shape is
 * treated as `unknown` and bridged to the locally hand-written
 * `AuthResponse` / `RefreshTokenResponse` interfaces at the boundary, where
 * the rest of the app already expects those shapes.
 */
import axios from '../../../app/axios';
import { env } from '@/shared/config/env';
import { LoginPayload, LogOutPayload, AuthResponse, RefreshTokenPayload, RefreshTokenResponse } from '../types';

// Auth endpoints live under a different host than the rest of the portal API
// (no `/api` suffix, paths mounted at the root), so every request below
// overrides the default axios `baseURL` with `env.api.authBaseUrl`.

export const loginApi = async (payload: LoginPayload): Promise<AuthResponse> => {
    const params = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
        params.append(key, value);
    });

    const response = await axios.post<unknown>("/signin", params, {
        baseURL: env.api.authBaseUrl,
        headers: {
        "Content-Type": "multipart/form-data",
        },
    });

    return response.data as AuthResponse;
};

// refresh token api
export const refreshTokenApi = async (payload: RefreshTokenPayload): Promise<RefreshTokenResponse> => {
    const response = await axios.post<unknown>("/refreshToken", payload, {
        baseURL: env.api.authBaseUrl,
    });

    return response.data as RefreshTokenResponse;
};

// logout api
export const logoutApi = async (payload: LogOutPayload): Promise<AuthResponse> => {

    const response = await axios.post<unknown>("/signout", payload, {
        baseURL: env.api.authBaseUrl,
    });

    return response.data as AuthResponse;
};
